<template>
  <svg class="co-icon" aria-hidden="true" :name="name">
    <use :href="svgHrefs[name]"></use>
  </svg>
</template>

<script>
export default {
  name: 'hr-co-icon',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  setup() {
    const iconList = [
      { name: 'attachment', id: 'attachment-icon' },
      { name: 'briefcase', id: 'briefcase-icon' },
      { name: 'dollar', id: 'dollar-icon' },
      { name: 'pound', id: 'pound-icon' },
      { name: 'person', id: 'person-icon' },
      { name: 'phone', id: 'phone-icon' },
      { name: 'star', id: 'star-icon' },
      { name: 'sign', id: 'sign-icon' },
      { name: 'rectangle-star', id: 'rectangle-star-icon' },
      { name: 'sparkle', id: 'sparkle-icon' },
      { name: 'tax', id: 'tax-icon' },
      { name: 'question', id: 'question-icon' },
      { name: 'document', id: 'document-icon' },
    ];
    const svgHrefs = iconList.reduce((map, currentObj) => {
      const iconName = currentObj.name;
      const id = currentObj.id;
      map[iconName] = `/icons/${iconName}.svg#${id}`;
      return map;
    }, {});
    return {
      svgHrefs,
    };
  },
};
</script>

<style scoped>
.co-icon {
  height: 1em;
  width: 1em;
  display: inline-block;
  font-size: 1em;
  fill: currentColor;
  overflow: hidden;
}

.co-icon[name='pound'] {
  font-size: 0.7em;
}
</style>
